import { PageLayout } from '@app/pages/layout/PageLayout'
import { useClient } from '@based/sdk/react'
import { useState, useEffect } from 'react'
import { useSearch } from 'wouter'
import { KnowledgeHubModule } from '@schema/knowledgeHubModule'
import { LeftSidebar } from '@app/components/layout/LeftSidebar'
import { KnowledgeHubModuleSidebar } from './KnowledgeHubModuleSidebar'
import { KnowledgeHubModuleContent } from './KnowledgeHubModuleContent'
import { useTranslations } from '@i18n/useLanguage'

export type KnowledgeHubItemPageProps = {
  itemId: string
}

export const KnowledgeHubModulePage = ({
  itemId,
}: KnowledgeHubItemPageProps) => {
  const t = useTranslations().app.knowledgeHubPage
  const [knowledgeHubModuleItem, setKnowledgeHubModuleItem] = useState<
    KnowledgeHubModule | undefined
  >()
  const search = useSearch()
  const itemSlug =
    new URLSearchParams(search).get('slug') ||
    knowledgeHubModuleItem?.sections?.[0]?.knowledgeHubItems?.[0]?.slug
  const client = useClient()

  useEffect(() => {
    const subscription = client
      .query('view-knowledge-hub-module', { id: itemId })
      .subscribe((p) => setKnowledgeHubModuleItem(p))

    return () => {
      if (typeof subscription === 'function') {
        subscription()
      }
    }
  }, [itemId, client])

  if (!knowledgeHubModuleItem) {
    return <PageLayout gap="2rem">{t.loading}</PageLayout>
  }

  return (
    <>
      <PageLayout gap="0rem">
        <LeftSidebar>
          <LeftSidebar.Sidebar collapsedButtonLabel={t.menu}>
            <KnowledgeHubModuleSidebar
              sections={knowledgeHubModuleItem.sections}
              activeSlug={itemSlug}
            />
          </LeftSidebar.Sidebar>

          <KnowledgeHubModuleContent id={itemSlug || ''} />
        </LeftSidebar>
      </PageLayout>
    </>
  )
}
